(() => {
  const boot = () => {
    const root = document.querySelector('[data-aw-configurator]');
    const panel = document.querySelector('[data-aw-p13-atelier-context]');
    if (!root || !panel) return;

    const params = new URLSearchParams(location.search);
    const handle = String(params.get('aw_service') || '').trim();
    if (!handle) return;

    const title = String(params.get('aw_service_title') || '').trim();
    root.dataset.awAtelierService = handle;
    panel.hidden = false;

    const titleNode = panel.querySelector('[data-aw-p13-service-title]');
    if (titleNode) titleNode.textContent = title || handle.replace(/-/g, ' ');

    const back = panel.querySelector('[data-aw-p13-service-return]');
    if (back) {
      back.href = '/products/' + encodeURIComponent(handle);
      back.hidden = false;
    }

    try {
      sessionStorage.setItem('aw_p13_service_context', JSON.stringify({ handle, title, capturedAt: Date.now() }));
    } catch (_) {}

    window.dispatchEvent(new CustomEvent('aw:p13-service-context', {
      detail: { handle, title: title || null }
    }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();